<template>
  <div class="custom-table">
    <div class="search-box" v-if="showSearchBox">
      <el-form
        size="mini"
        :inline="true"
        :model="searchForm"
        ref="searchFormRef"
      >
        <template v-for="(item, index) in tableItemConfigValue">
          <template v-if="item.enableSearch">
            <el-form-item :key="index">
              <template v-if="item.searchType === 'input'">
                <el-input
                  v-model="searchForm[item.key]"
                  :style="{ width: item.searchWidth }"
                  :placeholder="'请输入' + item.title"
                ></el-input>
              </template>
              <template v-if="item.searchType === 'select'">
                <el-select
                  v-model="searchForm[item.key]"
                  size="mini"
                  :style="{ width: item.searchWidth }"
                  :placeholder="'请输入' + item.title"
                >
                  <el-option
                    v-for="(item, index) in item.options"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </template>
        </template>
        <el-form-item>
          <slot
            name="search"
            :page="currentPage"
            :searchForm="searchForm"
          ></slot>
        </el-form-item>
      </el-form>
    </div>
    <div
      v-if="exportEnable || showTableConfig || showTableRefresh || importEnable"
      style="
        position: relative;
        width: 100%;
        height: 30px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
      "
    >
      <el-button
        v-if="exportEnable"
        type="warning"
        plain
        size="mini"
        icon="el-icon-download"
        @click="exportAction"
      >
        导出
      </el-button>
      <el-button
        v-if="importEnable"
        type="warning"
        plain
        size="mini"
        icon="el-icon-top"
        @click="importAction"
      >
        导入
      </el-button>
      <slot name="topTool"></slot>
      <el-button
        v-if="
          clearDataEnable &&
          (userInfo.permission === '超级管理员' ||
            userInfo.permission === '赛事管理员')
        "
        type="danger"
        plain
        style="margin-left: 10px"
        size="mini"
        @click="clearAction"
      >
        清空数据
      </el-button>
      <div
        style="
          position: absolute;
          right: 0;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <el-button
          v-if="showTableRefresh"
          plain
          size="mini"
          circle
          icon="el-icon-refresh"
          @click="queryAction"
        >
        </el-button>
        <el-button
          v-if="
            showTableConfig &&
            (userInfo.permission === '超级管理员' ||
              userInfo.permission === '赛事管理员')
          "
          circle
          icon="el-icon-date"
          size="mini"
          @click="openConfig"
        ></el-button>
        <el-button
          v-if="
            importConfigEnable &&
            (userInfo.permission === '超级管理员' ||
              userInfo.permission === '赛事管理员')
          "
          circle
          icon="el-icon-c-scale-to-original"
          size="mini"
          @click="editTableItemVisibleExport = true"
        ></el-button>
      </div>
    </div>
    <Table
      v-if="tableStyle === 'vd'"
      :row-key="rowKey"
      stripe
      :border="border"
      :columns="vdColumns"
      :fit="true"
      style="margin-top: 10px"
      width="100%"
      size="default"
      :tree-props="treeProps"
      :load-data="handleLoadData"
      :header-class-name="tableRowClassName"
      header-align="center"
      :data="data"
      @on-selection-change="handleVdSelectionChange"
    ></Table>
    <el-table
      ref="ccElTable"
      v-if="tableStyle === 'el'"
      :border="border"
      stripe
      :data="data"
      style="width: 100%; margin-top: 10px"
      :row-key="
        typeof rowKey === 'string'
          ? rowKey
          : typeof rowKey === 'function'
          ? (row) => rowKey(row)
          : ''
      "
      :default-expand-all="defaultExpandAll"
      :columns="tableItemConfigValue"
      :header-cell-style="{
        backgroundColor: headerBgColorTable,
        color: headerFontColorTable,
        fontWeight: 'none',
        'text-align': 'center',
        height: headerHeightTable + 'px',
        'font-size': headerFontSizeTable + 'px',
      }"
      :row-style="{
        height: exportHeightTable + 'px',
        color: '#555555',
        'text-align': 'center',
      }"
      :tree-props="treeProps"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="selectionEnable"
        type="selection"
        width="55"
        align="center"
        :selectable="selectable"
      >
      </el-table-column>
      <slot
        name="table-item"
        :config="tableItemConfigValue"
        :headerFontSizeTable="headerFontSizeTable"
      ></slot>
    </el-table>
    <div class="pagination" v-if="showPageBox">
      <div></div>
      <div v-if="data.length !== 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="currentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 70, 100, 200, 300, 400]"
          :page-size="currentPage.pageSize"
          :total="currentPage.total"
        >
        </el-pagination>
      </div>
    </div>
    <Modal title="表格列属性" v-model="editTableItemVisible" width="60%">
      <el-alert
        title="字体列宽度等于0时,表格字段宽度自适应"
        :closable="false"
        type="warning"
      >
      </el-alert>
      <div
        style="
          width: 100%;
          height: 30px;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <div
          style="font-size: 14px; color: #1fa4ff; cursor: pointer"
          @click="reset"
        >
          恢复默认值
        </div>
      </div>
      <el-form inline>
        <el-form-item label="行高(磅):">
          <el-input-number
            size="mini"
            placeholder="行高"
            v-model="exportHeightTable"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="name" label="表头背景色">
          <el-color-picker v-model="headerBgColorTable"></el-color-picker>
        </el-form-item>
        <el-form-item prop="name" label="表头字体颜色">
          <el-color-picker v-model="headerFontColorTable"></el-color-picker>
        </el-form-item>
        <el-form-item prop="name" label="表头字体大小">
          <el-input-number
            size="mini"
            v-model="headerFontSizeTable"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="name" label="表头高度">
          <el-input-number
            size="mini"
            v-model="headerHeightTable"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <el-table
        stripe
        :header-cell-style="{
          backgroundColor: '#F9F9F9',
          color: '#555555',
          fontWeight: 'none',
          height: '40px',
        }"
        :row-style="{ height: '40px', fontSize: '14px', color: '#555555' }"
        size="mini"
        :data="tableItemConfigValueConfig"
      >
        <el-table-column prop="title" label="列名"></el-table-column>
        <el-table-column prop="name" label="字体大小">
          <template slot-scope="scope">
            <el-input-number
              size="mini"
              v-model="scope.row.fontSize"
              autocomplete="off"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="字体颜色">
          <template slot-scope="scope">
            <el-color-picker v-model="scope.row.fontColor"></el-color-picker>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="列宽度">
          <template slot-scope="scope">
            <el-input-number
              :min="0"
              size="mini"
              v-model="scope.row.width"
              autocomplete="off"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="是否显示">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.show"></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="editTableItemVisible = false"
          >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="commitConfigAction"
          >确 定</el-button
        >
      </div>
    </Modal>
    <Modal
      title="导出表格属性"
      v-model="editTableItemVisibleExport"
      width="60%"
    >
      <el-alert
        title="字体列宽度等于0时,表格字段宽度自适应"
        :closable="false"
        type="warning"
      >
      </el-alert>
      <div
        style="
          width: 100%;
          height: 30px;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <div
          style="font-size: 14px; color: #1fa4ff; cursor: pointer"
          @click="resetExport"
        >
          恢复默认值
        </div>
      </div>
      <el-form inline label-width="150px" label-position="right">
        <el-form-item label="行高(磅):">
          <el-input-number
            size="mini"
            placeholder="行高"
            v-model="exportHeight"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <el-form inline label-width="150px" label-position="right">
        <el-form-item prop="name" label="表头背景色">
          <el-color-picker v-model="headerBgColor"></el-color-picker>
        </el-form-item>
        <el-form-item prop="name" label="表头字体颜色">
          <el-color-picker v-model="headerFontColor"></el-color-picker>
        </el-form-item>
        <el-form-item prop="name" label="表头字体大小">
          <el-input-number
            size="mini"
            v-model="headerFontSize"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="name" label="表头高度">
          <el-input-number
            size="mini"
            v-model="headerHeight"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <el-form
        inline
        label-width="150px"
        label-position="right"
        v-if="configName === 'jtHzongList' || configName === 'tlHzongList'"
      >
        <el-form-item prop="name" label="赛事名称背景色">
          <el-color-picker v-model="saiHeaderBgColor"></el-color-picker>
        </el-form-item>
        <el-form-item prop="name" label="赛事名称字体颜色">
          <el-color-picker v-model="saiHeaderFontColor"></el-color-picker>
        </el-form-item>
        <el-form-item prop="name" label="赛事名称字体大小">
          <el-input-number
            size="mini"
            v-model="saiHeaderFontSize"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="name" label="赛事名称高度">
          <el-input-number
            size="mini"
            v-model="saiHeaderHeight"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <el-form
        inline
        label-width="150px"
        label-position="right"
        v-if="configName === 'jtHzongList' || configName === 'tlHzongList'"
      >
        <el-form-item prop="name" label="代表队信息背景色">
          <el-color-picker v-model="desHeaderBgColor"></el-color-picker>
        </el-form-item>
        <el-form-item prop="name" label="代表队信息字体颜色">
          <el-color-picker v-model="desHeaderFontColor"></el-color-picker>
        </el-form-item>
        <el-form-item prop="name" label="代表队信息字体大小">
          <el-input-number
            size="mini"
            v-model="desHeaderFontSize"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="name" label="代表队信息高度">
          <el-input-number
            size="mini"
            v-model="desHeaderHeight"
            autocomplete="off"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <el-table
        stripe
        :header-cell-style="{
          backgroundColor: '#F9F9F9',
          color: '#555555',
          fontWeight: 'none',
          height: '40px',
        }"
        :row-style="{ height: '40px', fontSize: '14px', color: '#555555' }"
        size="mini"
        :data="tableItemExportConfigValueConfig"
      >
        <el-table-column prop="name" label="列名"></el-table-column>
        <el-table-column prop="name" label="字体大小">
          <template slot-scope="scope">
            <el-input-number
              size="mini"
              v-model="scope.row.fontSize"
              autocomplete="off"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="字体颜色">
          <template slot-scope="scope">
            <el-color-picker v-model="scope.row.fontColor"></el-color-picker>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="列宽度">
          <template slot-scope="scope">
            <el-input-number
              :min="0"
              size="mini"
              v-model="scope.row.width"
              autocomplete="off"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="是否显示">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.show"></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="editTableItemVisibleExport = false"
          >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="commitExportConfigAction"
          >确 定</el-button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
//exportAnnouncementConfig,
import {
  exportAgeCategoryConfig,
  exportAthleteConfig,
  exportPaymentConfig,
  exportProjectCategoryConfig,
  exportTeamConfig,
  exportTeamStatisticsConfig,
  exportUserConfig,
  getByUserId,
  getExportByUserId,
  setData,
  setExportData,
} from "@/api";
import moment from "moment";
import { Message } from "element-ui";
import {
  exceltoneConfig,
  exceltwoConfig,
  exportAllJtAthleteStatisticsConfig,
  exportAllTlAthleteStatisticsConfig,
} from "@/api/bmItempai";

export default {
  name: "CustomTable",
  props: {
    tableStyle: {
      type: String,
      default: "vd",
    },
    data: {
      type: [Array, Object],
      default: () => [],
    },
    page: {
      type: Object,
      default: () => {
        return {
          pageSize: 20,
          pageNum: 1,
          total: 0,
        };
      },
    },
    configName: {
      type: String,
      default: "",
    },
    tableItemConfig: {
      type: Array,
      default: () => [],
    },
    showSearchBox: {
      type: Boolean,
      default: false,
    },
    showPageBox: {
      type: Boolean,
      default: true,
    },
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    showTableConfig: {
      type: Boolean,
      default: false,
    },
    treeProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    rowKey: {
      type: [String, Function],
      default: "id",
    },
    height: {
      type: Number,
      default: 1200,
    },
    showTableRefresh: {
      type: Boolean,
      default: false,
    },
    exportEnable: {
      type: Boolean,
      default: false,
    },
    importEnable: {
      type: Boolean,
      default: false,
    },
    clearDataEnable: {
      type: Boolean,
      default: false,
    },
    importConfigEnable: {
      type: Boolean,
      default: false,
    },
    teamId: {
      type: [String, Number],
      default: "",
    },
    selectionEnable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
      editTableItemVisibleExport: false,
      editTableItemVisible: false,
      currentPage: {
        pageSize: 20,
        pageNum: 1,
        total: 11,
      },
      searchForm: {},
      tableItemConfigValue: [],
      tableItemConfigValueConfig: [],
      exportHeight: 40,

      headerBgColor: "#C7C7C7",
      headerFontColor: "#000000",
      headerHeight: 40,
      headerFontSize: 13,

      saiHeaderBgColor: "#C7C7C7",
      saiHeaderFontColor: "#000000",
      saiHeaderHeight: 40,
      saiHeaderFontSize: 13,

      desHeaderBgColor: "#C7C7C7",
      desHeaderFontColor: "#000000",
      desHeaderHeight: 40,
      desHeaderFontSize: 13,

      exportHeightTable: 40,
      headerBgColorTable: "#F7F7F7",
      headerFontColorTable: "#5C6B77",
      headerHeightTable: 40,
      headerFontSizeTable: 13,

      tableItemExportConfigValueConfig: [],
      selection: [],
    };
  },
  computed: {
    ...mapState(["screenHeight", "screenWidth", "userInfo", "eventInfo"]),
    vdColumns() {
      let columns = this.tableItemConfigValue;
      if (this.selectionEnable && this.tableStyle === "vd") {
        // 插入选择列作为第一列
        const selectionColumn = {
          type: "selection",
          width: 55,
          selectable: this.selectable,
          align: "center",
        };
        columns = [selectionColumn, ...columns];
      }
      return columns;
    },
  },
  watch: {
    page: {
      handler(val) {
        this.currentPage = val;
      },
      deep: true,
      immediate: true,
    },
    searchForm: {
      handler(val) {
        this.$emit("searchFormChange", val);
      },
      deep: true,
      immediate: true,
    },
    tableItemConfigValue: {
      immediate: true,
      handler(newVal) {
        this.tableItemConfigValueConfig = newVal;
      },
      deep: true,
    },
    tableItemConfig: {
      immediate: true,
      handler(newVal) {
        this.updateConfig();
        let tempSearchForm = {};
        newVal.forEach((a) => {
          if (a.enableSearch === true) {
            tempSearchForm[a.key] = a.searchDefault;
            console.log(tempSearchForm, "tempSearchForm");
            console.log(a, "a");
          }
        });
        this.searchForm = tempSearchForm;
      },
      deep: true,
    },
  },
  mounted() {
    this.updateConfig();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      // 根据条件返回不同的类名
      return "headerRowClassName";
    },
    resetExport() {
      this.initExportConfig();
    },
    handleLoadData(item, callback) {
      this.$emit("load-data", item, callback);
    },
    setPage(page) {
      this.currentPage = page;
    },
    queryAction() {
      this.$emit("query");
    },
    exportAction() {
      this.$emit("export");
    },
    clearAction() {
      this.$emit("clear");
    },
    importAction() {
      this.$emit("import");
    },
    initExportConfig() {
      this.exportHeight = 40;
      this.headerBgColor = "#C7C7C7";
      this.headerFontColor = "#000000";
      this.headerHeight = 40;
      this.headerFontSize = 13;

      this.saiHeaderBgColor = "#C7C7C7";
      this.saiHeaderFontColor = "#000000";
      this.saiHeaderHeight = 40;
      this.saiHeaderFontSize = 13;

      this.desHeaderBgColor = "#C7C7C7";
      this.desHeaderFontColor = "#000000";
      this.desHeaderHeight = 40;
      this.desHeaderFontSize = 13;

      // this.tableItemExportConfigValueConfig = []

      if (this.configName === "tlbpTable") {
        exportAllTlAthleteStatisticsConfig().then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "jtbpTable") {
        exportAllJtAthleteStatisticsConfig().then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "userList") {
        exportUserConfig().then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "athleteList") {
        exportAthleteConfig().then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "homeFile") {
        exportTeamStatisticsConfig().then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "teamList") {
        exportTeamConfig().then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "ProjectCategoryList") {
        exportProjectCategoryConfig().then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "AgeCategoryList") {
        exportAgeCategoryConfig().then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "paymentList") {
        exportPaymentConfig().then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "AnnouncementList") {
        // exportAnnouncementConfig().then((res) => {
        //   if (res.data.code === 200) {
        //     this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
        //       return {
        //         width: 0,
        //         fontSize: 13,
        //         fontColor: "#000000",
        //         name: a,
        //         show: true,
        //       };
        //     });
        //   }
        // });
      }
      if (this.configName === "jtHzongList") {
        exceltoneConfig({
          teamId: this.teamId,
          userId:
            this.userInfo.permission === "超级管理员" ||
            this.userInfo.permission === "赛事管理员"
              ? undefined
              : this.userInfo.id,
          competitionId:
            this.userInfo.permission === "超级管理员"
              ? undefined
              : this.eventInfo
              ? this.eventInfo.id
              : undefined,
        }).then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
      if (this.configName === "tlHzongList") {
        exceltwoConfig({
          teamId: this.teamId,
          userId:
            this.userInfo.permission === "超级管理员" ||
            this.userInfo.permission === "赛事管理员"
              ? undefined
              : this.userInfo.id,
          competitionId:
            this.userInfo.permission === "超级管理员"
              ? undefined
              : this.eventInfo
              ? this.eventInfo.id
              : undefined,
        }).then((res) => {
          if (res.data.code === 200) {
            this.tableItemExportConfigValueConfig = res.data.result.map((a) => {
              return {
                width: 0,
                fontSize: 13,
                fontColor: "#000000",
                name: a,
                show: true,
              };
            });
          }
        });
      }
    },
    updateConfig() {
      if (this.configName.length > 0) {
        getExportByUserId({
          name: this.configName,
          competitionId:
            this.userInfo.permission === "超级管理员"
              ? undefined
              : this.eventInfo
              ? this.eventInfo.id
              : undefined,
        }).then((res) => {
          if (res.data.code !== 0) {
            let tempResult = JSON.parse(res.data.result.data);
            this.tableItemExportConfigValueConfig = tempResult.list;
            this.exportHeight = tempResult.exportHeight;
            this.headerHeight = tempResult.headerHeight;
            this.headerBgColor = tempResult.headerBgColor;
            this.headerFontSize = tempResult.headerFontSize;
            this.headerFontColor = tempResult.headerFontColor;
            this.saiHeaderBgColor = tempResult.saiHeaderBgColor;
            this.saiHeaderFontColor = tempResult.saiHeaderFontColor;
            this.saiHeaderHeight = tempResult.saiHeaderHeight;
            this.saiHeaderFontSize = tempResult.saiHeaderFontSize;

            this.desHeaderBgColor = tempResult.desHeaderBgColor;
            this.desHeaderFontColor = tempResult.desHeaderFontColor;
            this.desHeaderHeight = tempResult.desHeaderHeight;
            this.desHeaderFontSize = tempResult.desHeaderFontSize;
          } else {
            this.initExportConfig();
          }
        });
        getByUserId({
          name: this.configName,
          competitionId:
            this.userInfo.permission === "超级管理员"
              ? undefined
              : this.eventInfo
              ? this.eventInfo.id
              : undefined,
        }).then((res) => {
          if (res.data.code === 200) {
            let tempResultTable = JSON.parse(res.data.result.data);

            let tempResult = tempResultTable.list;
            this.exportHeightTable = tempResultTable.exportHeight;
            this.headerHeightTable = tempResultTable.headerHeight;
            this.headerBgColorTable = tempResultTable.headerBgColor;
            this.headerFontSizeTable = tempResultTable.headerFontSize;
            this.headerFontColorTable = tempResultTable.headerFontColor;

            let getTempItem = (key) => {
              let arr = tempResult.filter((item) => {
                return item.key === key;
              });
              if (arr.length > 0) {
                return arr[0];
              } else {
                return null;
              }
            };
            this.tableItemConfigValue = this.tableItemConfig.map(
              (item, index) => {
                let itemValueInfo = getTempItem(item.key);
                let info = {
                  ...item,
                  fontColor: itemValueInfo
                    ? itemValueInfo.fontColor
                    : item.fontColor,
                  fontSize: itemValueInfo
                    ? itemValueInfo.fontSize
                    : item.fontSize,
                  width: itemValueInfo ? itemValueInfo.width : item.width,
                  show: itemValueInfo ? itemValueInfo.show : item.show,
                };
                if (!info.render) {
                  info.render = (h, params) => {
                    return h(
                      "div",
                      {
                        style: {
                          color: params.column.fontColor,
                          fontSize: params.column.fontSize + "px",
                          marginLeft: params.column.tree ? "10px" : "0px",
                          height: this.exportHeightTable + "px",
                        },
                      },
                      params.row[params.column.key]
                    );
                  };
                }
                const originalRender = info.render;
                info.render = (h, params) => {
                  const style = {
                    color: params.column.fontColor,
                    fontSize: `${params.column.fontSize}px`,
                    marginLeft: params.column.tree ? "10px" : "0px",
                    height: this.exportHeightTable + "px",
                    lineHeight: this.exportHeightTable + "px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    justifyContent:
                      params.column.align === "left" ? "flex-start" : "center",
                  };

                  // 创建外层容器添加公共样式
                  return h("div", { style }, [originalRender(h, params)]);
                };
                info.renderHeader = (h, params) => {
                  return h(
                    "div",
                    {
                      style: {
                        color: this.headerFontColorTable,
                        fontSize: this.headerFontSizeTable + "px",
                        height: this.headerHeightTable + "px",
                        backgroundColor: this.headerBgColorTable,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                    },
                    info.title
                  );
                };
                return info;
              }
            );
            this.$emit("query");
          } else {
            this.chuLiFrom();
            this.$emit("query");
          }
        });
      } else {
        this.chuLiFrom();
        this.$emit("query");
      }
    },
    openConfig() {
      this.editTableItemVisible = true;
    },
    chuLiFrom() {
      this.tableItemConfigValue = this.tableItemConfig
        .map((item) => {
          let info = {
            ...item,
          };
          if (!info.render) {
            info.render = (h, params) => {
              return h(
                "div",
                {
                  style: {
                    color: params.column.fontColor,
                    fontSize: params.column.fontSize + "px",
                    marginLeft: params.column.tree ? "10px" : "0px",
                  },
                },
                params.row[params.column.key]
              );
            };
          }
          const originalRender = info.render;
          info.render = (h, params) => {
            const style = {
              color: params.column.fontColor,
              fontSize: `${params.column.fontSize}px`,
              marginLeft: params.column.tree ? "10px" : "0px",
              height: this.exportHeightTable + "px",
              lineHeight: this.exportHeightTable + "px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              paddingLeft: "10px",
              paddingRight: "10px",
              justifyContent:
                params.column.align === "left" ? "flex-start" : "center",
            };

            // 创建外层容器添加公共样式
            return h("div", { style }, [originalRender(h, params)]);
          };
          info.renderHeader = (h, params) => {
            return h(
              "div",
              {
                style: {
                  color: this.headerFontColorTable,
                  fontSize: this.headerFontSizeTable + "px",
                  height: this.headerHeightTable + "px",
                  backgroundColor: this.headerBgColorTable,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                },
              },
              info.title
            );
          };
          return info;
        })
        .filter((a) => {
          return a.show;
        });
    },
    commitExportConfigAction() {
      if (this.configName.length > 0) {
        setExportData({
          name: this.configName,
          data: JSON.stringify({
            exportHeight: this.exportHeight,
            headerHeight: this.headerHeight,
            headerBgColor: this.headerBgColor,
            headerFontSize: this.headerFontSize,
            headerFontColor: this.headerFontColor,
            saiHeaderBgColor: this.saiHeaderBgColor,
            saiHeaderFontColor: this.saiHeaderFontColor,
            saiHeaderHeight: this.saiHeaderHeight,
            saiHeaderFontSize: this.saiHeaderFontSize,
            desHeaderBgColor: this.desHeaderBgColor,
            desHeaderFontColor: this.desHeaderFontColor,
            desHeaderHeight: this.desHeaderHeight,
            desHeaderFontSize: this.desHeaderFontSize,
            list: this.tableItemExportConfigValueConfig,
          }),
          competitionId:
            this.userInfo.permission === "超级管理员"
              ? undefined
              : this.eventInfo
              ? this.eventInfo.id
              : undefined,
        }).then((res) => {
          if (res.data.code === 200) {
            this.editTableItemVisibleExport = false;
          } else {
            Message.error("配置失败!");
          }
        });
      }
    },
    commitConfigAction() {
      if (this.configName.length > 0) {
        setData({
          name: this.configName,
          data: JSON.stringify({
            exportHeight: this.exportHeightTable,
            headerHeight: this.headerHeightTable,
            headerBgColor: this.headerBgColorTable,
            headerFontSize: this.headerFontSizeTable,
            headerFontColor: this.headerFontColorTable,
            list: this.tableItemConfigValueConfig,
          }),
          competitionId:
            this.userInfo.permission === "超级管理员"
              ? undefined
              : this.eventInfo
              ? this.eventInfo.id
              : undefined,
        }).then((res) => {
          if (res.data.code === 200) {
            this.editTableItemVisible = false;
          } else {
            Message.error("配置失败!");
          }
        });
      }
    },
    resetSearchForm() {
      let tempSearchForm = {};
      for (const searchFormKey in this.searchForm) {
        tempSearchForm[searchFormKey] = "";
      }
      this.searchForm = tempSearchForm;
      this.$emit("searchFormChange", tempSearchForm);
    },
    currentChange(index) {
      this.currentPage.pageNum = index;
      this.$emit("pageChange", this.currentPage);
    },
    handleSizeChange(size) {
      this.currentPage.pageSize = size;
      this.$emit("pageChange", this.currentPage);
    },
    indexMethod(index) {
      return this.currentPage.pageSize * this.currentPage.pageNum + 1 + index;
    },
    reset() {
      this.exportHeightTable = 40;
      this.headerBgColorTable = "#F7F7F7";
      this.headerFontColorTable = "#5C6B77";
      this.headerHeightTable = 40;
      this.headerFontSizeTable = 13;
      this.chuLiFrom();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
      this.$emit("selection-change", selection);
    },
    handleVdSelectionChange(selection) {
      this.selection = selection;
      this.$emit("selection-change", selection);
    },
    selectable(row, index) {
      // 默认所有行可选
      return true;
    },
  },
};
</script>
<style>
.el-table__body {
  width: 100% !important;
}

.el-table__header {
  width: 100% !important;
}

.headerRowClassName {
  height: 100px !important;
}

.ivu-table-header thead tr th {
  padding: 0 !important;
}

.ivu-table-fixed-header tr th {
  padding: 0 !important;
}

.ivu-table-cell {
  width: 100% !important;
  padding: 0 !important;
}
</style>
<style scoped lang="scss">
.custom-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .search-box {
    width: 100%;
    text-align: left;
  }

  .pagination {
    margin-top: 15px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  //.el-form-item {
  //  margin-bottom: 0 !important;
  //}
}
</style>
